import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


//Serives
import { HttpService } from 'src/app/modules/shared/services/http.service';

//Models
import { ColumnSettingsN, UpdateColumnSettings } from '../models/column-settings.model';

@Injectable({
    providedIn: 'root'
})

export class SharedColumnSettingsService {
    baseConfigURL: string;

    constructor(
        private httpService: HttpService) {
        this.baseConfigURL = environment.configUrlV2;
    }

    getColumnSettings(moduleId: number, channelId: number): Observable<any> {
        return this.httpService.getById(`${this.baseConfigURL}/ColumnSetting/Module/${moduleId}/Channel/${channelId}`);
    }

    updateColumnSettings(updateData: Partial<UpdateColumnSettings>){
        return this.httpService.update(`${this.baseConfigURL}/ColumnSetting`, updateData);
    }

    resetColumnSettings(moduleId: number, channelId: number): Observable<any> {
        return this.httpService.update(`${this.baseConfigURL}/ColumnSetting/Reset/Module/${moduleId}/Channel/${channelId}`);
    }

    //for account 
    getColumnSettingsForSavedSearch(moduleId: number, channelId: number,saveSearchId:number){
        return this.httpService.getById(`${this.baseConfigURL}/ColumnSetting/Module/${moduleId}/Channel/${channelId}/SavedSearch/${saveSearchId}`);
    }

    updateColumnSettingsForSavedSearch(data){
        return this.httpService.put(`${this.baseConfigURL}/ColumnSetting/SavedSearch`,data);
    }
}
